/* eslint-disable react/style-prop-object */
import React, { useContext, useState, useMemo } from "react";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { useGetSubmittalsEnumsQuery } from "../../../Redux/service/Submittals/Submittals";
import { useGetPOIProjectsQuery } from "../../../Redux/service/POIS/POIs";
import { toast } from "react-toastify";
import Button from "../../Helpers/Button/Button";
import { FileExcelOutlined } from "@ant-design/icons";

export default function SubmittalsHead({ setFilter, filter = {} }) {
	const { setSearchQuery, searchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const [exporting, setExporting] = useState(false);
	const { data } = useGetSubmittalsEnumsQuery();
	const { data: projects } = useGetPOIProjectsQuery();
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	/**
	 * Download the Excel report for exactly what is on screen.
	 *
	 * The backend applies the same filters and role scoping as the list endpoint, so the
	 * current filter/search state is forwarded verbatim. Follows the IR download pattern
	 * (InspectionRequestRevisions.jsx): fetch as a blob so the auth header and session
	 * cookie are sent, rather than a bare link.
	 */
	const handleExport = async () => {
		if (exporting) return;
		setExporting(true);

		const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
		const params = new URLSearchParams({ lang });
		Object.entries(filter).forEach(([key, value]) => {
			if (value !== null && value !== "" && value !== undefined) {
				params.append(key, value);
			}
		});
		if (searchQuery) params.append("search", searchQuery);

		const url = `${process.env.REACT_APP_BACKEND2_URL}/v1/submittals/export/excel?${params}`;

		try {
			const response = await fetch(url, {
				method: "GET",
				credentials: "include",
				headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
			});

			if (!response.ok) {
				toast.error(
					response.status === 404
						? trans("No submittals found matching the criteria")
						: trans("Failed to download Excel"),
					{ autoClose: 2500, rtl: lang === "ar" }
				);
				return;
			}

			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = downloadUrl;
			link.download = `Submittals-Report-${new Date().toISOString().slice(0, 10)}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(downloadUrl);
		} catch (error) {
			console.error("Error downloading submittals Excel:", error);
			toast.error(trans("Failed to download Excel"), { autoClose: 2500 });
		} finally {
			setExporting(false);
		}
	};
	const { typeOptions, disciplineOptions, statusOptions } = useMemo(() => {
		if (!data?.data)
			return { typeOptions: [], disciplineOptions: [], statusOptions: [] };

		const { SubmittalType, SubmittalDiscipline, SubmittalStatus } = data.data;
		const convertToOptions = (obj) =>
			Object.entries(obj).map(([key, value]) => ({
				label: trans(value),
				value: key,
			}));

		return {
			typeOptions: convertToOptions(SubmittalType),
			disciplineOptions: convertToOptions(SubmittalDiscipline),
			statusOptions: convertToOptions(SubmittalStatus),
		};
	}, [data]);

	return (
		<div className="bg-white p-16 d-flex align-items-baseline gap-3 flex-wrap">
			<Searchbar
				style="search search-dark input-group"
				path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
				placeholder={trans("Search")}
				value={query}
				onChange={handleSearch}
			/>

			<InputSelect
				placeholder={trans("Type")}
				options={typeOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, type: e }))}
			/>

			<InputSelect
				placeholder={trans("Discipline")}
				options={disciplineOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, discipline: e }))}
			/>

			<InputSelect
				placeholder={trans("Status")}
				options={statusOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, status: e }))}
			/>
			<InputSelect
				placeholder={trans("Project")}
				options={projects?.data?.map((i) => {
					return { label: i.name, value: i.id };
				})}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, projectId: e }))}
			/>

			<Button
				type="default"
				className="flex-shrink-0"
				onClick={handleExport}
				loading={exporting}
				disabled={exporting}
				icon={<FileExcelOutlined />}
				text={trans("Export to Excel")}
				tooltip={trans("Exports the submittals currently shown, with their revisions")}
			/>
		</div>
	);
}
